import { Link } from "react-router-dom";
import { getToken } from "../../helpers";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";

const Navbar = () => {
  const products = useSelector((state) => state.cart.products);
  const wishes = useSelector((state) => state.wishlist.products);

  const { data, loading, error } = useFetch(`/categories?populate=*`, 'NoToken');

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-dark navbar-light d-none d-lg-block" id="templatemo_nav_top">
          <div className="container text-light">
              <div className="w-100 d-flex justify-content-between">
                  <div>
                      <i className="fa fa-envelope mx-2"></i>
                      <Link className="navbar-sm-brand text-light text-decoration-none" to="mailto:contact@rankcave.com">contact@rankcave.com</Link>
                      <i className="fa fa-phone mx-2"></i>
                      <Link className="navbar-sm-brand text-light text-decoration-none" to="tel:+91-9625956699">+91-9625956699</Link>
                  </div>
                  <div>
                      <Link className="text-light" to="https://fb.com/rankcave" target="_blank" rel="sponsored"><i className="fab fa-facebook-f fa-sm fa-fw me-2"></i></Link>
                      <Link className="text-light" to="https://www.instagram.com/" target="_blank"><i className="fab fa-instagram fa-sm fa-fw me-2"></i></Link>
                      <Link className="text-light" to="https://twitter.com/" target="_blank"><i className="fab fa-twitter fa-sm fa-fw me-2"></i></Link>
                      <Link className="text-light" to="https://www.linkedin.com/" target="_blank"><i className="fab fa-linkedin fa-sm fa-fw"></i></Link>
                  </div>
              </div>
          </div>
      </nav>
      
      <nav className="navbar navbar-expand-lg navbar-light shadow">
          <div className="container d-flex justify-content-between align-items-center">
              <Link className="navbar-brand text-success logo h1 align-self-center" to="/"><img className="logo" src="/img/rank_logo.png" alt="Rankcave Ecommerce" /></Link>
              
              <button className="navbar-toggler border-0" type="button" data-bs-toggle="collapse" data-bs-target="#templatemo_main_nav" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
              </button>

              <div className="align-self-center collapse navbar-collapse flex-fill  d-lg-flex justify-content-lg-between" id="templatemo_main_nav">
                  <div className="flex-fill">
                      <ul className="nav navbar-nav d-flex justify-content-between mx-lg-auto">
                          <li className="nav-item ">
                            <Link className="nav-link nav-font" to="/about">About</Link>
                          </li>
                          {data?.map((item) => (
                            <li key={item.id} className="nav-item">
                                <a href="#" className="nav-link nav-font dropdown-toggle submenu">{item.title}</a>
                                <div className="submenuBlock">
                                    <div className="card card-body">
                                        <div className="row">
                                            {item.sub_categories.map((sub) => (
                                                <div key={sub.id} className="col-md-4"><Link className="nav-link nav-font" to={`/products/${item.title_slug}?sub_categories=${sub.title_slug}`}>{sub.title}</Link></div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </li>
                          ))}
                          <li className="nav-item">
                            <Link className="nav-link nav-font" to="/contact">Contact</Link>
                          </li>
                      </ul>
                  </div>
                  <div className="navbar align-self-center d-flex">
                      <div className="d-lg-none flex-sm-fill mt-3 mb-4 col-7 col-sm-auto pr-3">
                          <div className="input-group">
                              {/*<input type="text" className="form-control" id="inputMobileSearch" placeholder="Search ...">
                              <div className="input-group-text">
                                  <i className="fa fa-fw fa-search"></i>
                              </div>*/}
                          </div>
                      </div>
                      {getToken() ? <Link className="nav-icon position-relative text-decoration-none" to="/profile"><i className="fa fa-fw fa-user text-dark mr-3"></i></Link>
                      : <Link className="nav-icon position-relative text-decoration-none" to="/signin"><i className="fa fa-fw fa-user text-dark mr-3"></i></Link>}
                      <Link className="nav-icon position-relative text-decoration-none" to="/wishlist">
                        <i className="fa fa-fw fa-heart text-dark mr-2"></i>
                        <span className="position-absolute top-0 left-100 translate-middle badge rounded-pill bg-light text-dark">{wishes.length}</span>
                      </Link>
                      <Link className="nav-icon position-relative text-decoration-none" to="/cart">
                          <i className="fa fa-fw fa-cart-arrow-down text-dark mr-1"></i>
                          <span className="position-absolute top-0 left-100 translate-middle badge rounded-pill bg-light text-dark">{products.length}</span>
                      </Link>
                  </div>
              </div>
          </div>
      </nav>
    </>
  );
};

export default Navbar;